// local hook used in the context of Risk Assessment
import { useMemo } from 'react';
import { colors } from './data';
import { Maybe, RiskType } from '@/__generated__/graphql';

export const useDataToGenerateMatrices = (
  yLabels: string[],
  xLabels: string[],
  data: Maybe<RiskType>[] | undefined
) => {
  return useMemo(() => {
    return Array.from({ length: yLabels.length }, (_row, rowIndex) =>
      Array.from({ length: xLabels.length }, (_column, columnIndex) => ({
        row: yLabels[rowIndex],
        column: xLabels[columnIndex],
      }))
    )
      .flat()
      .map(({ row, column }) => {
        const unmitigatedValue = data?.find((item) => item?.value === `${column}${row}`);
        return {
          row,
          column,
          count: unmitigatedValue?.count ?? 0,
          color: colors[`${column}${row}`],
        };
      });
  }, [data, xLabels, yLabels]);
};
